import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './checkbox.js';

const css = ".ispui-select-toggle{display:-ms-flexbox;display:flex;font-family:inherit;font-size:var(--ispui-select-toggle__fs, 14px)}.ispui-select-toggle[hidden]{display:none}.ispui-select-toggle__checkbox{--ispui-checkbox__size:var(--ispui-select-toggle__checkbox-size, 13px);--ispui-checkbox__pl:var(--ispui-select-toggle__checkbox-pl, 25px);--ispui-checkbox__margin-right:var(--ispui-select-toggle__checkbox-margin-right, 0);pointer-events:none}.ispui-select-toggle__plain-text{cursor:pointer}.ispui-select-toggle__plain-text_bold{font-weight:bold}.ispui-select-toggle__plain-text_disabled{pointer-events:none;opacity:0.5}";

const ToggleDefault = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.toggle = createEvent(this, "toggle", 7);
    /** text when not all options are selected */
    this.onText = 'Выбрать все';
    /** text when all options are selected */
    this.offText = 'Снять выбор';
    /** is disabled */
    this.disabled = false;
    /** is checked */
    this.checked = false;
    /** toggle type */
    this.type = 'checkbox';
    /** Show minus icon and onText */
    this.partialSelected = false;
  }
  get text() {
    return this.partialSelected ? this.onText : this.offText;
  }
  render() {
    const checkbox = (h("div", { class: "ispui-select-toggle__checkbox-wrapper", onClick: () => this.toggle.emit(!this.checked) }, h("ispui-checkbox", { class: { 'ispui-select-toggle__checkbox': true }, block: true,
      // style={{ 'pointerEvents': 'none', '--ispui-checkbox__size': '13px', '--ispui-checkbox__pl': '15px', '--ispui-checkbox__margin-right': '0px' }}
      checked: this.checked, minus: this.partialSelected, disabled: this.disabled }, this.text)));
    const bold = (h("span", { onClick: () => this.toggle.emit(!this.checked), class: { 'ispui-select-toggle__plain-text': true, 'ispui-select-toggle__plain-text_disabled': this.disabled, 'ispui-select-toggle__plain-text_bold': this.checked } }, this.text));
    const layouts = { checkbox, bold };
    return h(Host, { class: "ispui-select-toggle" }, layouts[this.type]);
  }
  static get style() { return css; }
}, [0, "ispui-select-toggle", {
    "onText": [1, "on-text"],
    "offText": [1, "off-text"],
    "disabled": [4],
    "checked": [4],
    "type": [1],
    "partialSelected": [4, "partial-selected"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-select-toggle", "ispui-checkbox"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-select-toggle":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ToggleDefault);
      }
      break;
    case "ispui-checkbox":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const IspuiSelectToggle = ToggleDefault;
const defineCustomElement = defineCustomElement$1;

export { IspuiSelectToggle, defineCustomElement };
